import { ReactNode } from 'react'
import { useParams } from 'react-router-dom'
import {
  Card,
  Description,
  ErrorCodeText,
  Label,
  Root
} from './ErrorPage.styles'

const { BOP_IDP_URL, SUPPORT_EMAIL } = process.env

const errorDescriptions: Record<string, ReactNode> = {
  '401': 'Ошибка 401. Не хватает прав для просмотра этой страницы.',
  '403': 'Ошибка 403. Доступ запрещен.',
  '404': 'Ошибка 404. Страница не найдена.',
  '404.1': (
    <p style={{ textAlign: 'left' }}>
      Не удалось определить жилой комплекс.
      <br />
      Это могло случиться после перехода со страницы{' '}
      <a href={BOP_IDP_URL}>«Паспорт объекта»</a>.
      <br />
      Пожалуйста, вернитесь на страницу объекта в{' '}
      <a href={BOP_IDP_URL}>«Паспорт объекта»</a> и попробуйте снова нажать
      кнопку перехода.
      <br />
      Если ошибка повторится — сообщите об этом в{' '}
      <a href={`mailto:${SUPPORT_EMAIL}`}>службу поддержки</a>.
    </p>
  )
}

export const ErrorPage = () => {
  const { errorCode } = useParams()
  const description =
    errorDescriptions[errorCode ?? ''] ?? 'Что-то пошло не так...'

  return (
    <Root>
      <Card>
        <Label>Код ошибки</Label>
        <ErrorCodeText>{errorCode}</ErrorCodeText>
        <Description>{description}</Description>
        {/*<HomeLink to="/">На главную</HomeLink>*/}
      </Card>
    </Root>
  )
}
